import * as React from 'react';
import ClipHTML from 'vkid-ui/lib/Components/ClipHTML';
import { HTML_CLASSES } from '../../../../../constants/product.constants';
import { useProductContext } from '../../../../../contexts/ProductContext';

export const ProductDescription: React.FC = () => {
    const { productConfig, labels } = useProductContext();

    if (!productConfig.description) {
        return null;
    }

    return (
        <div className={HTML_CLASSES.PRODUCT_BLOCK}>
            {labels.descriptionTitle && <h2 className={HTML_CLASSES.PRODUCT_BLOCK_TITLE}>{labels.descriptionTitle}</h2>}
            <div className={HTML_CLASSES.LONGTEXT}>
                <ClipHTML
                    dom={productConfig.description}
                    config={{
                        labelShowMore: labels?.showMore || '',
                        labelShowLess: labels?.showLess || '',
                    }}
                />
            </div>
        </div>
    );
};
